import { createLogger } from '@derstandard/logger';

/**
 * A simple wrapper for `@derstandard/logger` to keep the code DRY.
 * @param prefix
 * @param bgColor
 * @returns
 */
export function Logger(prefix: string, bgColor = 'lightseagreen'): ReturnType<typeof createLogger> {
	return createLogger(prefix, {
		bgColor,
		color: '#fff',
	});
}
